export default "/assets/17594485f5c46bfa.svg"